import {Component, Inject, AfterViewInit, ElementRef, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

export interface DialogData {
  html: string;
}

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'dialog-termsAndConditions',
  template: require('./dialog-termsAndConditions.template.html'),
  styles: [require('./dialog-termsAndConditions.style.css')]
})
export class DialogTermsAndConditionsComponent implements AfterViewInit {
  @ViewChild('content') content: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DialogTermsAndConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }
  ngAfterViewInit() {
    this.content.nativeElement.innerHTML = this.data.html;
  }


  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/dialog-termsAndConditions/dialog-termsAndConditions.component.ts